import * as React from 'react';
import {injectIntl} from 'react-intl';
import {BlankPage} from "./common/styles";

const Blank = () => {

    return (
        <BlankPage/>
    );
};

export default injectIntl(Blank);
